import { render, staticRenderFns } from "./aiInterview.vue?vue&type=template&id=17c73052&scoped=true"
import script from "./aiInterview.vue?vue&type=script&lang=js"
export * from "./aiInterview.vue?vue&type=script&lang=js"
import style0 from "./aiInterview.vue?vue&type=style&index=0&id=17c73052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c73052",
  null
  
)

export default component.exports